/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'sarsaparilla';

const propTypes = {
    index: PropTypes.number,
    removeLeader: PropTypes.func,
    handleAlternateLeaderChange: PropTypes.func,
    leader: PropTypes.shape({
        fName: PropTypes.string,
        mName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        lName: PropTypes.string,
    }),
    isDisabled: PropTypes.bool,
};

const defaultProps = {
    isDisabled: false,
};

export default class AlternateGroupLeader extends React.Component {
    constructor(props) {
        super(props);
        this.onClickRemove = this.onClickRemove.bind(this);
    }

    onClickRemove() {
        const index = parseInt(this.props.index, 10);
        this.props.removeLeader(index);
    }

    handleChange(event) {
        const input = event.target.value;
        const id = event.target.id;
        this.props.handleAlternateLeaderChange(this.props.index, id, input);
    }

    renderRemoveLeaderButton() {
        if (this.props.isDisabled) {
            return <div />;
        }

        return (
            <Button
                type="button"
                appearance="subtle-danger"
                className="removeLeaderLink"
                screenReaderTextBefore={`Remove the Alternate Permit Holder #${this.props.index + 1}`}
                iconBeforeElement={<Icon iconName="delete" />}
                onClick={this.onClickRemove}
            />
        );
    }

    render() {
        const { leader } = this.props;
        return (
            <div data-testid="alternate-group-leader" className="per-form-group-item">
                <div className="per-form-group-item-header">
                    <div className="per-form-group-item-title">
                        Alternate Permit Holder #{this.props.index + 1}
                    </div>
                    {this.renderRemoveLeaderButton()}
                </div>
                <div className="rec-form-item-wrap">
                    <label className="rec-label" htmlFor="other-email">
                        Email Address
                    </label>
                    <input
                        id="other-email"
                        type="text"
                        value={leader.email}
                        onChange={(e) => {
                            this.handleChange(e);
                        }}
                        readOnly={this.props.isDisabled}
                        disabled={this.props.isDisabled}
                    />
                </div>
            </div>
        );
    }
}

AlternateGroupLeader.propTypes = propTypes;
AlternateGroupLeader.defaultProps = defaultProps;
